import React, {useCallback, useMemo} from "react";
import {PcGender} from "./pc/PcGender";
import {MobileGender} from "./mobile/MobileGender";
import { useImagePreloader } from "../../../../hooks/useImagePreloader";
import { getFastingGenderImage } from "../common/genderAgeProfile";

function Gender({isMobile, ...props}) { // 接收 isMobile props
    const { data, clickNext, clickPrev } = props;
    
    // Define image options to match Image component defaults
    const imageOptions = {
        quality: 100,
        formatSize: 1
    };
    
    // Get male body type images
    const maleBodyTypeImages = useMemo(() => [
        "/static/image/questionnaire/fasting/currentBodyType/male_skinny@3x.png",
        "/static/image/questionnaire/fasting/currentBodyType/male_regular@3x.png",
        "/static/image/questionnaire/fasting/currentBodyType/male_extra@3x.png",
        "/static/image/questionnaire/fasting/targetBodyType/male_cut.png",
        "/static/image/questionnaire/fasting/targetBodyType/male_bulk.png",
        "/static/image/questionnaire/fasting/targetBodyType/male_extra_bulk.png"
    ], []);
    
    // Get female body type images
    const femaleBodyTypeImages = useMemo(() => [
        "/static/image/questionnaire/fasting/currentBodyType/female_regular@3x.png",
        "/static/image/questionnaire/fasting/currentBodyType/female_plump@3x.png",
        "/static/image/questionnaire/fasting/currentBodyType/female_extra@3x.png",
        "/static/image/questionnaire/fasting/targetBodyType/female_fit.png",
        "/static/image/questionnaire/fasting/targetBodyType/female_muscular.png",
        "/static/image/questionnaire/fasting/targetBodyType/female_shapely.png"
    ], []);
    
    // Preload body type images for male
    const { preloadImages: preloadMaleImages } = useImagePreloader(maleBodyTypeImages, false, imageOptions);
    
    // Preload body type images for female
    const { preloadImages: preloadFemaleImages } = useImagePreloader(femaleBodyTypeImages, false, imageOptions);
    
    // Preload all gender images
    const allGenderImages = useMemo(() => {
        return [
            "/static/image/questionnaire/fasting/gender/GenderFemale20.png",
            "/static/image/questionnaire/fasting/gender/GenderFemale40.png",
            "/static/image/questionnaire/fasting/gender/GenderFemale60.png",
            "/static/image/questionnaire/fasting/gender/GenderFemale80.png",
            "/static/image/questionnaire/fasting/gender/GenderMale20.png",
            "/static/image/questionnaire/fasting/gender/GenderMale40.png",
            "/static/image/questionnaire/fasting/gender/GenderMale60.png",
            "/static/image/questionnaire/fasting/gender/GenderMale80.png"
        ];
    }, []);

    useImagePreloader(allGenderImages, true, imageOptions);

    // Wrap clickNext to preload corresponding body type images
    const handleClickNext = useCallback((gender) => {
        // Preload body type images based on selected gender
        if (gender === 'male') {
            preloadMaleImages(maleBodyTypeImages);
        } else if (gender === 'female') {
            preloadFemaleImages(femaleBodyTypeImages);
        }
        
        // Call original clickNext
        if (clickNext) {
            clickNext(gender);
        }
    }, [clickNext, preloadMaleImages, preloadFemaleImages, maleBodyTypeImages, femaleBodyTypeImages]);

    const returnImage = (isFemale) => {
        return getFastingGenderImage(isFemale ? "female" : "male", data.ageRange);
    }
    
    // Build common props with wrapped clickNext
    const commonProps = {
        ...props,
        clickNext: handleClickNext,
        clickPrev: clickPrev || (() => {})
    };

    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobileGender returnImage={returnImage} {...commonProps} />;
    } else {
        return <PcGender returnImage={returnImage} {...commonProps} />;
    }
}

export default Gender;
